<template>
  <div class="">
    <div class="board-top">
      <el-tabs v-model="activeName">
        <el-tab-pane label="联采" name="first">
          <div class="ifram-box">
            <iframe
              :src="vs"
              frameborder="0"
              style="width: 100%; overflow: hidden;"
              class="all-height"
            ></iframe>
          </div>
        </el-tab-pane>
        <el-tab-pane label="物流" name="second">
          <div class="ifram-box">
            <iframe
              :src="wlsc"
              frameborder="0"
              style="width: 100%; overflow: hidden;"
              class="all-height"
            ></iframe>
          </div>
        </el-tab-pane>
        <el-tab-pane label="租赁" name="third">
          <div class="ifram-box">
            <iframe
              :src="yz"
              frameborder="0"
              style="width: 100%; overflow: hidden;"
              class="all-height"
            ></iframe>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- <div class="ifram-box">
      <iframe
        :src="iframeSrc"
        frameborder="0"
        style="width: 100%; overflow: hidden;"
        class="all-height"
      ></iframe>
    </div> -->
  </div>
</template>

<script>
import { addUrlPerFix } from "@/basa/utils";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      activeName: "first",
      src: "",
      iframeSrc: "",
      vs: "",
      wlsc: "",
      yz: ""
    };
  },
  watch: {
    activeName(newVal, oldVal) {
      let src = "";
      if (newVal === "first") {
        src = "vs.iccec.cn/secondHomepage";
      } else if (newVal === "second") {
        src = "wlsc.iccec.cn/dataPage";
      } else if (newVal === "third") {
        src = "yz.iccec.cn/dataBoard";
      }
      this.src = addUrlPerFix(src);
      const token = Cookies.get("access_token") || "";
      this.iframeSrc = `${this.src}?token=${token}&t=${new Date().getTime()}`;
    }
  },
  mounted() {
    console.log("board-page mounted");
    document.title = "数据看板";
    if (document.querySelector(".ccui-top-bar-wrapper")) {
      document.querySelector(".ccui-top-bar-wrapper").style.display = "none";
    }
    this.src = addUrlPerFix("vs.iccec.cn/secondHomepage");
    const token = Cookies.get("access_token") || "";
    this.iframeSrc = `${this.src}?token=${token}&t=${new Date().getTime()}`;
    this.getSrc();
  },
  methods: {
    getSrc() {
      const token = Cookies.get("access_token") || "";
      this.vs =
        addUrlPerFix("vs.iccec.cn/secondHomepage") +
        "?token=" +
        token +
        "&t=" +
        new Date().getTime();
      this.wlsc =
        addUrlPerFix("wlsc.iccec.cn/dataPage") +
        "?token=" +
        token +
        "&t=" +
        new Date().getTime();
      this.yz =
        addUrlPerFix("yz.iccec.cn/dataBoard") +
        "?token=" +
        token +
        "&t=" +
        new Date().getTime();
    }
  }
};
</script>

<style lang="scss" scoped>
.ifram-box {
  max-width: 1720px;
  display: flex;
  justify-content: center;
  margin: 0 auto;
}

.all-height {
  height: calc(100vh - 50px);
}

/deep/ .el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
  background: #fff;
}

/deep/ .el-tabs__header {
  margin: 0 0 10px;
}

/deep/ .el-tabs__nav-wrap::after {
  background-color: transparent;
}

/deep/ .el-tabs__item {
  font-weight: bold;
}
</style>
